module.exports = __webpack_public_path__ + "media/assets/images/logos/leanbit_logo_square-3b19070d9236a6aadfa4399fa5a7dc11.jpg";